import React from 'react'

import Map from 'components/shared/Map'
import ClustererGoogleMap from 'components/shared/Map/ClustererGoogleMap'

interface IProps {
  geos: any[]
  viewTankInfo: (tankId: string) => void
  geoZoneSelected?
}
const MapView = ({ geos, viewTankInfo,geoZoneSelected }: IProps) => (
  <Map geo={geos} Map={ClustererGoogleMap} onMarkerClicked={viewTankInfo} geoZoneSelected={geoZoneSelected} />
)

export default React.memo(MapView)
